import React, {useContext, useEffect, useState} from "react";
import ThisYearsGipDownloadComponent from "./Components/ThisYearGipDownloadComponent";
import PastGipDownloadComponent from "./Components/PastGipDownloadComponent";
import ToolTipComponent from "./Components/ToolTipComponent";
import './GipDownloadStyle.css'
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import {YearReportData} from "../../interfaces/RankingsAndLevelsInterfaces";

import { useTranslation } from "react-i18next";

const GipDownloadContent: React.FC = () => {
    const [showToolTip, setShowTooltip] = useState<boolean>(false);
    const [hoverToolTipCounter, setHoverToolTipCounter] = useState<number>(0);

    const [thisYearReportURL, setThisYearReportURL] = useState<YearReportData>({ id: '', year: 2019, download_urls: {}});
    const [pastYearsReportURL, setPastYearsReportURL] = useState<YearReportData[]>();

    // @ts-ignore
    const { reportsAvailables, lastYearAvailable, allDataLoaded } = useContext(GlobalDataContext);

    const { t } = useTranslation();

    const closeToolTip = () => {
        setShowTooltip(false);
    };

    const openToolTip = () => {
        if(!showToolTip && hoverToolTipCounter < 3){
            setHoverToolTipCounter(hoverToolTipCounter + 1);
            setShowTooltip(true);
        }
    };

    useEffect(() => {
        setTimeout(() => setShowTooltip(true), 3000);
    }, []);

    useEffect(() => {
        if (allDataLoaded) {
            const years = Object.keys(reportsAvailables).sort().reverse().slice(1, 6);
            const pastReports = years.map((year: string) => reportsAvailables[Number(year)]);

            setThisYearReportURL(reportsAvailables[lastYearAvailable]);
            setPastYearsReportURL(pastReports);
        }
    }, [allDataLoaded]);

    return(
        <React.Fragment>
            <div className='contentCContainer'>
                <div className='contentTitle'>
                    { t('pdfDownload.header.title-top') } <br/> { t('pdfDownload.header.title-bottom') }
                </div>
                <div className='contentSubTitle' onMouseEnter={openToolTip} onClick={() => {setShowTooltip(true)}}>
                    { t('pdfDownload.header.subtitle') }
                </div>
                <ThisYearsGipDownloadComponent downloadReport={thisYearReportURL} />
                <PastGipDownloadComponent pastYearsReportURL={pastYearsReportURL}/>
            </div>
            <ToolTipComponent showToolTip={showToolTip} closeToolTip={closeToolTip}/>
        </React.Fragment>
    )
};

export default GipDownloadContent;
